// Shared processing-time formatter. Only verified estimates are shown; otherwise a
// neutral review-based label. No silent working-day/calendar-day conversion, no guarantees.
export const TIMELINE_QUALIFIER = {
  formation: "Estimated processing time starts after complete KYC/document approval.",
  banking: "Timing depends on the financial institution and compliance review.",
  licensing: "Timing may depend on regulator review and additional information requests.",
};

export function hasTimeline(value) {
  return !!(value || "").trim();
}

export function timelineText(value) {
  const t = (value || "").trim();
  return t || "Timeline confirmed after preliminary review";
}
